import requestCountry from 'js/lib/requestCountry';

import type { WaiverType } from 'bundles/degree-description/data/appFeeWaiverData';
import { appFeeWaiverData } from 'bundles/degree-description/data/appFeeWaiverData';
import { showAppFeeWaiverExperiment } from 'bundles/degree-description/utils/experiments';

export type AppFeeWaiver = {
  waiverType: WaiverType.LINK | WaiverType.CODE | WaiverType.EMAIL;
  applicationLink?: string;
  promoCode?: string;
  email?: string;
  emailSubject?: string;
  deadline?: string;
  fee?: string;
  availableRegion?: string[];
  excludeRegion?: string[];
};

export const getAppFeeWaiverProps = (slug: string) => ({
  type: appFeeWaiverData[slug]?.waiverType,
  code: appFeeWaiverData[slug]?.promoCode,
  link: appFeeWaiverData[slug]?.applicationLink,
  deadline: appFeeWaiverData[slug]?.deadline,
  fee: appFeeWaiverData[slug]?.fee,
  availableRegion: appFeeWaiverData[slug]?.availableRegion,
  excludeRegion: appFeeWaiverData[slug]?.excludeRegion,
  email: appFeeWaiverData[slug]?.email,
  emailSubject: appFeeWaiverData[slug]?.emailSubject,
});

export const isAppFeeWaiverValidDeadline = (deadline?: string) => {
  if (!deadline) return true;

  const [month, day, year] = deadline.split('-').map(Number);
  const currentDay = new Date();
  currentDay.setHours(0, 0, 0, 0);

  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const deadlineDate = new Date(year, month - 1, day);

  return deadlineDate.getTime() >= currentDay.getTime();
};

const isRegionAvailable = (userRegion: string, availableRegion?: string[], excludeRegion?: string[]) => {
  if ((!availableRegion || availableRegion?.length === 0) && (!excludeRegion || excludeRegion?.length === 0)) {
    return true;
  }
  if (availableRegion?.includes(userRegion)) {
    return true;
  }
  return !excludeRegion?.includes(userRegion);
};

export const showAppFeeWaiver = (slug: string, hasAppFeeWaiverQualification?: boolean) => {
  const { deadline, availableRegion, excludeRegion } = getAppFeeWaiverProps(slug);
  const userRegion = requestCountry.get();
  const isValidRegion = isRegionAvailable(userRegion, availableRegion, excludeRegion);
  return (
    // Important to have hasAppFeeWaiverQualification check first, as we only want to impress users who are qualified.
    hasAppFeeWaiverQualification &&
    !!appFeeWaiverData[slug] &&
    isValidRegion &&
    showAppFeeWaiverExperiment() &&
    isAppFeeWaiverValidDeadline(deadline)
  );
};
